<ng-container *ngIf="show; else content">
  <ng-container [ngSwitch]="variant">
    <div *ngSwitchCase="'conf'"><skeletor-conf [items]="items"></skeletor-conf></div>

    <div *ngSwitchCase="'card'"><skeletor-card></skeletor-card></div>

    <div *ngSwitchCase="'list'"><skeletor-list [items]="items"></skeletor-list></div>

    <div *ngSwitchCase="'table'"><skeletor-table [items]="items"></skeletor-table></div>

    <div *ngSwitchCase="'clasif'"><skeletor-clasif [items]="items"></skeletor-clasif></div>
    <div *ngSwitchCase="'request-data'"><skeletor-request-data [items]="items"></skeletor-request-data></div>
    <div *ngSwitchCase="'document-requirements'"><skeletor-document-requirements [items]="items"></skeletor-document-requirements></div>
    <div *ngSwitchCase="'type-sheets'"><skeletor-type-sheets [items]="items"></skeletor-type-sheets></div>
    <div *ngSwitchCase="'socios-negocio'"><skeletor-socios-negocio [items]="items"></skeletor-socios-negocio></div>
    <div *ngSwitchCase="'partner-detail'"><skeletor-partner-detail [items]="items"></skeletor-partner-detail></div>
    <div *ngSwitchCase="'base-home'"><skeletor-base-home [items]="items"></skeletor-base-home></div>
    <div *ngSwitchCase="'create-supplier'"><skeletor-create-supplier [items]="items"></skeletor-create-supplier></div>

    <div *ngSwitchDefault class="skeletor-text">
      <p-skeleton width="100%" class="mb-2" />
      <p-skeleton width="75%" class="mb-2" />
      <p-skeleton width="50%" />
    </div>
  </ng-container>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
